<template lang="html">
<div class="layout-div__container clearfix">
                <div class="layout-div__title">
                    <span class="layout-span__title__text">
                        <i class="layout-i__line"></i>黑头毛孔
                    </span>
                </div>
                <div class="layout-div__body">
                    <div class="sr-div__acne">
                        <div class="sr-div__blackheads">
                            <img src="./imgs/icon-blackhead@2x.png" alt="黑头个数">
                            <p class="sr-p__type">黑头个数</p>
                            <i class="sr-i__degree">{{blackhead.blackheadNumber}}</i>
                        </div>
                        <div class="sr-div__blackheads">
                            <img src="./imgs/icon-degree@2x.png" alt="黑头个数">
                            <p class="sr-p__type">黑头程度</p>
                            <i class="sr-i__degree">{{blackhead.blackheadSeverity}}</i>
                        </div>
                        <div class="sr-div__blackheads">
                            <img src="./imgs/icon-pore@2x.png" alt="黑头个数">
                            <p class="sr-p__type">毛孔</p>
                            <i class="sr-i__degree">{{blackhead.poreSeverity}}</i>
                        </div>
                    </div>

                    <ul class="sr-ul__result__group clearfix">
                        <li class="sr-li__result__item">
                            你存在 <i class="layout-i__font big-font">{{blackhead.blackheadSeverity}}的黑头问题</i>
                        </li>
                        <li style="margin-top:5px;">
                            {{blackhead.blackheadAdvice}}
                        </li>
                    </ul>

                </div>
            </div>
</template>

<script>
/* eslint-disable */
export default {
  beforeMount() {
    let {
      blackhead_number,
      blackhead_severity,
      short_blackhead_advice,
      pore_severity
    } = this.$store.state.result.resultData;
    this.blackhead = Object.assign(
      {},
      {
        blackheadNumber: blackhead_number,
        blackheadSeverity: blackhead_severity,
        poreSeverity: pore_severity,
        blackheadAdvice: short_blackhead_advice
      }
    );
  },
  data() {
    return {
      blackhead: {
        blackheadNumber: 0,
        blackheadSeverity: "",
        poreSeverity: "",
        blackheadAdvice: ""
      }
    };
  }
};
</script>

<style scoped>
.sr-div__acne {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 5.3vw;
}
.sr-div__blackheads {
  width: 33.33%;
}
.sr-div__blackheads img {
  width: 67.2413%;
  height: auto;
  display: block;
  margin: 0 auto;
}
.sr-p__type {
  margin: 0;
  display: block;
  color: #909090;
  font-size: 14px;
  text-align: center;
}

.sr-i__degree {
  font-size: 18px;
  color: #000;
  font-style: normal;
  margin-top: 0.21rem;
  display: block;
  text-align: center;
}
.sr-ul__result__group {
  margin: 0;
  padding: 0;
  display: block;
  list-style: none;
  margin-top: 8vw;
  font-size: 4vw;
}
.sr-ul__result__group li {
  font-family: "PingFangSC";
}
.sr-li__result__item {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Result/blackhead.vue